import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import DesktopOnlyCard from 'atoms/DesktopOnlyCard'

const styles = {
  root: {
    margin: 'auto',
    maxWidth: 400,
  }
}

const CenteredCard = ({ classes, ...rest }) => (
  <div className={classes.root}>
    <DesktopOnlyCard {...rest} />
  </div>
)

CenteredCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(CenteredCard)
